<app-slide id="termsSlide" title="Terms and Conditions"
    supportingText="We need you to accept these terms and conditions before you submit your application"
    [slideNumber]="slideNumber" [finalSlide]="finalSlide" [active]="active.active === 'terms'"
    [slideCompleted]="formState.progress.termsComplete">
    <div class="alert alert-danger" *ngIf="showError">
        {{errorMessage}}
    </div>

    <div id="termsForm">
        <fieldset>
            <legend class="sr-only">Terms and conditions</legend>
            <div class="section">
                <div class="form-group">
                    <div class="square_checkbox">
                        <input type="checkbox" id="privacy_checkbox" name="privacy_checkbox" class="sr-only"
                            [formControl]="termsAcceptedControl" required>
                        <label for="privacy_checkbox">By checking the box you agree to our <a
                                (click)="showModal($event)" class="link-underline">Terms
                                and Conditions and Privacy Policy</a></label>
                    </div>
                </div>
                <div class="btn-set clearfix">
                    <button type="button" name="button" class="btn btn-default btn-back"
                        (click)="onBack()">Back</button>
                    <button type="submit" (click)="onSubmit()" name="button" class="btn btn-primary btn-send"
                        [disabled]="termsAcceptedControl.invalid">
                        <span>Send Application Securely</span>
                        <app-spinner *ngIf="submitting" class="applicationSubmitSpinner"></app-spinner>
                    </button>
                </div>
            </div>
        </fieldset>
    </div>
</app-slide>

<style>
    .link-underline {
        cursor: pointer;
    }
</style>


<div id="termsAndConditionsModal" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg terms">
        <div class="modal-content">
            <!--Header-->
            <div class="modal-header">
                <div class="terms__header">
                    <h4 class="modal-title" id="modal-label">
                        <span class="terms__header__title">
                            {{termsAndConditionsPageHeading}}
                        </span>
                    </h4>
                    <p class="terms__header__sub-title">
                    </p>
                </div>
            </div>

            <!--Body-->
            <div class="modal-body terms__body" [innerHTML]="termsAndConditionsBodyText">
                {{termsAndConditionsBodyText}}
            </div>

            <!--Footer-->
            <div class="modal-footer">
                <button class="btn btn-primary" type="button" (click)="hideModal()">OK</button>
            </div>
        </div>
    </div>
</div>